import React from 'react'
import { useParams } from 'react-router-dom'


export const Agreement = () => {

    let {name} = useParams()

    return (
        <div className='top-container'>
            <h5>Agreement Page</h5>
            <hr/>
            <div>{name}</div>
        </div>
    )


}

